module.exports = __webpack_public_path__ + "img/gold-left.f3bde32b.png";